export enum FlatplanViewType {
    Image,
    Description,
}
